import { j as o } from "../../jsx-runtime-ClSzPYp4.js";
import n from "../BaseIcon.mjs";
const c = (s) => /* @__PURE__ */ o.jsx("svg", {
  viewBox: "0 0 24 24",
  "aria-label": "Info",
  ...s,
  children: /* @__PURE__ */ o.jsx("g", {
    children: /* @__PURE__ */ o.jsx("path", {
      d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2z M13,17.99h-2   v-8h2V17.99z M13,8.01h-2v-2h2V8.01z"
    })
  })
}), a = (s) => /* @__PURE__ */ o.jsx(n, {
  IconSvg: c,
  ...s
});
export {
  a as default
};
